import { updatePrimaryPalette } from "@primevue/themes";
import Aura from "@primevue/themes/aura";
import { fr } from "primelocale/fr.json";
import { App } from "vue";

import PrimeVue from "primevue/config";

const PRIMEVUE_POPOVER_BACKGROUND_COLOR = "var(--color-primary)";
const PRIMEVUE_POPOVER_STYLE = {
  backgroundColor: PRIMEVUE_POPOVER_BACKGROUND_COLOR,
  borderRadius: "9999px",
};
const PRIMEVUE_TOOLTIP_TEXT_STYLE = {
  ...PRIMEVUE_POPOVER_STYLE,
  boxShadow: "0 1px 4px rgb(0 0 0 / 8%), 0 2px 5px rgb(103 110 118 / 8%)",
  fontSize: "12px",
  lineHeight: "1.25",
  maxWidth: "min(260px, calc(100vw - 32px))",
  padding: "8px 12px",
  textAlign: "center",
  whiteSpace: "normal",
  width: "max-content",
};
const PRIMEVUE_TOOLTIP_ROOT_STYLE = {
  maxWidth: "min(260px, calc(100vw - 32px))",
  width: "max-content",
};

export function setPrimeVuePrimaryColor() {
  updatePrimaryPalette({
    50: "{blue.50}",
    100: "{blue.100}",
    200: "{blue.200}",
    300: "{blue.300}",
    400: "{blue.400}",
    500: "{blue.500}",
    600: "{blue.600}",
    700: "{blue.700}",
    800: "{blue.800}",
    900: "{blue.900}",
    950: "{blue.950}",
  });
}

export function usePrimeVuePlugin() {
  return {
    install: (app: App) => {
      app.use(PrimeVue, {
        theme: {
          preset: Aura,
          options: {
            darkModeSelector: ".dark",
          },
        },
        locale: fr,
        pt: {
          directives: {
            tooltip: {
              root: {
                style: PRIMEVUE_TOOLTIP_ROOT_STYLE,
              },
              text: {
                style: PRIMEVUE_TOOLTIP_TEXT_STYLE,
              },
            },
          },
        },
      });
    },
  };
}
